import { THEME_FETCHED_SUCCESS } from '../constants/constants';

export const initialState = {
  colors: ['#fff', '#333', '#444'],
  ribbon: ['#fff', '#333', '#444'],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case THEME_FETCHED_SUCCESS:
      return {
        ...state,
        ...action.payload.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/theme.js